module.exports = __webpack_public_path__ + "media/components/assets/icons/label_live-82bcc572f2778d537e8ef56c99f8b11b.svg";